export default "__VITE_PUBLIC_ASSET__e45d5e5c__"